
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","height":"24","viewBox":"0 0 24 24","width":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"m19.7724 16.238-6.1109-11.25558c-.1618-.29726-.4007-.54539-.6916-.71828-.291-.17289-.6231-.26414-.9616-.26414-.3384 0-.6706.09125-.9615.26414-.291.17289-.5299.42102-.6917.71828l-6.11714 11.25558c-.16011.2874-.2421.6117-.2378.9407.00431.3289.09475.651.26233.9341.16757.2831.40642.5173.69274.6794.28631.162.61009.2461.93906.244h12.22181c.3262.0003.647-.0842.9308-.2453.2837-.161.5207-.3931.6878-.6733.167-.2803.2583-.5992.2649-.9254s-.0717-.6486-.2272-.9354zm-8.702-8.03074c0-.2496.0991-.48897.2756-.66546s.4159-.27564.6655-.27564.4889.09915.6654.27564.2757.41586.2757.66546v4.32284c0 .2496-.0992.4889-.2757.6654s-.4158.2757-.6654.2757-.489-.0992-.6655-.2757-.2756-.4158-.2756-.6654zm.9662 8.47624c-.2135 0-.4221-.0633-.5996-.1819-.1774-.1186-.3158-.2871-.3974-.4843-.0817-.1972-.1031-.4142-.0614-.6235.0416-.2093.1444-.4016.2953-.5525.1509-.151.3432-.2537.5525-.2954.2094-.0416.4263-.0202.6235.0614.1972.0817.3657.22.4843.3975s.1819.3861.1819.5995c0 .2862-.1137.5607-.3161.7631s-.4768.3161-.763.3161z","fill":"#4a3428"}})])
          )
        }
      }
    